import React from 'react';

import { Text } from '~/components/core';

import ClaimBarPill from '../components/ClaimBarPill';

type ScopeBannerProps = {
  label: string;
  scope: 'custom' | 'default';
  lastUpdated: string | null;
  action?: React.ReactNode;
};

const ScopeBanner = ({ label, scope, lastUpdated, action }: ScopeBannerProps) => (
  <div className="flex items-center justify-between gap-12 rounded-md border border-solid border-slate-400 bg-slate-100 px-16 py-12">
    <div className="flex min-w-0 items-center gap-12">
      <ClaimBarPill label={label} scope={scope} />
      {lastUpdated ? (
        <Text variant={Text.VARIANTS.SM} colorVariant={Text.COLOR_VARIANTS.SECONDARY} className="truncate">
          {lastUpdated}
        </Text>
      ) : null}
    </div>
    {action}
  </div>
);

export default ScopeBanner;
